import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { get } from 'lodash';

import currency from 'utils/currency';
import ImageReturn from 'assets/images/return-box.svg';
import { AdjustmentAlertCard } from 'components/Account/Transactions/TransactionAdjustment/TransactionAdjustmentContent';
import {
  Hr,
  AdjustmentWeightDiv,
  TransactionAdjustmentCard
} from 'components/Styled';

export const ReturnWeightCard = props => {
  const { t } = useTranslation();
  const transaction = get(props, 'transaction');
  const shipment = get(transaction, 'shipments[0]');
  const shipments = get(transaction, 'shipments');
  let firstCharges, returnCharges;
  if (shipments.length === 1) {
    firstCharges = transaction.totalCharges;
    returnCharges = transaction.returnFee;
  } else {
    firstCharges = shipment.firstRate;
    returnCharges = shipment.firstRate;
  }

  firstCharges = new currency(firstCharges);
  returnCharges = new currency(returnCharges);

  return (
    <TransactionAdjustmentCard>
      <div className="adjustment-header m-b-15 title">
        {t('confirmReturn.header')}
        {/* <span className="button-icon" onClick={() => {}}>
          <FontAwesomeIcon icon="info-circle" />
        </span> */}
      </div>
      <Hr />
      <div className="content">
        <AdjustmentWeightDiv>
          <div className="">
            <p className="small-font">{t('confirmReturn.paidCharges')}</p>
            <small className="large-font">
              {firstCharges.currency}
            </small>
            <span className="xxxlarge-font price">
              {firstCharges.format(false, true)}
            </span>
            <FontAwesomeIcon className="arrow-icon" icon="angle-right" />
          </div>
          <div>
            <p className="small-font">{t('confirmReturn.returnCharges')}</p>
            <small className="large-font">
              {returnCharges.currency}
            </small>
            <span className="xxxlarge-font price">
              {returnCharges.format(false, true)}
            </span>
          </div>
        </AdjustmentWeightDiv>
      </div>
    </TransactionAdjustmentCard>
  );
};

const TransactionReturnContent = props => {
  const { t } = useTranslation();
  const shipment = props.shipment;
  const transaction = props.transaction;
  return (
    <>
      <AdjustmentAlertCard
        image={ImageReturn}
        html={t('confirmReturn.remarks')}
      />
      <ReturnWeightCard shipment={shipment} transaction={transaction} />
    </>
  );
};

export default TransactionReturnContent;
